import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { IntlActions } from 'react-redux-multilingual'
import { withTranslate, translate } from 'react-redux-multilingual';
import Pace from 'react-pace-progress'
import $ from 'jquery'
import { toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';
import { getAllSearchResults } from "../../../actions/searchFilters"



// Import custom components
import store from '../../../store';
import NavBar from "./common/app-nav-bar";
import Filter from "../../search/common/filter";
import Sidebar from "react-sidebar";
import CartContainer from "../../../containers/CartContainer";
import TopBar from "./common/app-top-bar";
import LogoImage from "./common/logo";
import { changeCurrency } from '../../../actions'
import { connect } from "react-redux";
import { clearUserDetails } from '../../../actions/user';
import { wishlistDefault, shopBagDefault, signInDefault, searchDefault, switchAccount, signOutDefault, storeDefault, homeDefault } from '../MangoIcons'
import { clearCapillaryDetails } from '../../../actions/easyRewards';


class HeaderOne extends Component {

  constructor() {
    super();
    this.state = {
      isLoading: false,
      sidebarOpen: false,  
    
    }
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
    this.handleSearch = this.handleSearch.bind(this)
    this.getSearchProducts = this.getSearchProducts.bind(this)
  }
 
  /*=====================
       Pre loader
  =========================*/
  // componentDidMount() {
  //   // setTimeout(function() {
  //   //     document.querySelector(".loader-wrapper").style = "display: none";
  //   // }, 2000);

  //   this.setState({ open: true });
  // }

  componentWillMount() {
    window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  onSetSidebarOpen(open) {
    if(open){
      document.getElementById('root').style.position = "fixed";
      document.getElementById('root').style.width = "100%";
      document.getElementById('root').style.height = "100%";
    } else {
      // 
      document.getElementById('root').style.position = "";
      document.getElementById('root').style.height = "";
    }
    this.setState({ sidebarOpen: open });
  }
  
  
  handleSearch = () => {
var idDiv= document.getElementById('searchDiv')
var ic = document.getElementById('icon')
if(idDiv.style.display !== "none")
{
idDiv.style.display='none';
ic.classList.remove('fa-close')
ic.classList.add('fa-search')


}
else {
  $(this).find("i").removeClass("fa-search").addClass("fa-close");
  ic.classList.add('fa-close')

idDiv.style.display='block';

}
  }

  handleScroll = () => {
    let number = window.pageXOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    // if (number >= 300) {
    //   if (window.innerWidth < 576) {
    //     document.getElementById("sticky").classList.remove('fixed');
    //   } else
    //     document.getElementById("sticky").classList.add('fixed');
    // } else {
    //   document.getElementById("sticky").classList.remove('fixed');
    // }
  }

  changeLanguage(lang) {
    store.dispatch(IntlActions.setLocale(lang))
  }

  openNav() {
    var openmyslide = document.getElementById("mySidenav");
    if (openmyslide) {
      openmyslide.classList.add('open-side')
    }
  }
  openSearch() {
    document.getElementById("search-overlay").style.display = "block";
  }

  closeSearch() {
    document.getElementById("search-overlay").style.display = "none";
  }

  load = () => {
    this.setState({ isLoading: true });
    fetch().then(() => {
      // deal with data fetched
      this.setState({ isLoading: false })
    })
  };

  //serach product page 

  getSearchProducts = () => {
    const connection_id = this.props
    const keyWord = document.getElementById('search').value;
    const options = {
      connection_id : this.props.connection_id,
      search_keyword : keyWord
    }
    if(document.getElementById('search').value.length == 0){
      toast.error("Please Enter Product details")

    }
    else {

      this.props.getAllSearchResults(options);
     this.props.history.push('/search')
    }
   
}
handleCustomerLogout(){
  this.props.clearUserDetails();
  this.props.clearCapillaryDetails();
        localStorage.removeItem('mobile_no')
        this.props.history.push('/csa-home')
}
  render() {
const cp = window.location.href ;
    const { translate,pshop_keyword_search,pshop_product_search, isAuth, bannerText, presentURL, consumer_mobile_no,store_details } = this.props;
    return (
      <div style={{position:'sticky',top:0,zIndex:200}} >

        {/*Banner Section*/}
        
        <div className="banner row topHeader" style={{display:'block',margin:'0%',minHeight:40,fontSize:14}}>
          <div style={{float:'left',padding:10}} className='column'>{store_details ? store_details.store_short_name : this.props.selectedStoreName}
          </div>
          <div style={{float:'right',padding:10}} className='column'>{store_details ? store_details.CSA_NAME : ''}
          </div>
          </div> 
        {/*Banner Section End*/}
        <header >
          {this.state.isLoading ? <Pace color="#27ae60" /> : null}
          {cp.includes('ack') === false  ? 
          <div className="mobile-fix-option" style={{ backgroundColor: "#FFFFFF" }}></div>
          : <div></div> }
          {/*Top Header Component*/}
          <TopBar />
          <div className="container" style={window.innerWidth < 567 ? {}:{marginBottom:6}}>
            <div className="row" style={{margin: "5px 0px 0px -28px"}}>
              <div className="col-sm-12">
                <div className="main-menu">
                  <div className="menu-left remove-nav">
                    {/* <div className="navbar"> */}
                    {/* <a href="javascript:void(0)" onClick={this.openNav}>
												<div className="bar-style"> <i className="fa fa-bars sidebar-bar" aria-hidden="true"></i></div>
											</a> */}
                    {/*SideBar Navigation Component*/}
                    {/* <SideBar/> */}
                    {/* </div> */}
                    <div className='row'>
                     
                    <div className="csa-brand-logo">
                    <LogoImage presentURL={presentURL}  logo={this.props.logo} />
                      {/* <LogoImage presentURL={presentURL} logo={this.props.logo[1]} /> */}
                    </div>
                    {pshop_keyword_search === 'Y' ? 
                  <div className='col-6' ><div>
                    <input type="text" placeholder="Search Products" id="search" name="search" style={{width: 170,
    height: 35,marginLeft:104}} onKeyPress={(e) => e.key === 'Enter' && this.getSearchProducts()}/>
  <button onClick={this.getSearchProducts} style={{backgroundColor:'transparent',position:'absolute',border:'none',top:8,left:265}}><i className="fa fa-search"></i></button>
                 </div></div> : '' } </div>
                   
       
                {/* <div>
                    <input type="text" placeholder="Search Products" id="search" name="search" style={{width: 170,
    height: 35,marginLeft:104}} onKeyPress={(e) => e.key === 'Enter' && this.getSearchProducts()}/>
  <button onClick={this.getSearchProducts} style={{backgroundColor:'transparent',position:'absolute',border:'none',top:15,left:270}}><i className="fa fa-search"></i></button>
                 </div>  */}
                   
             
                    
                 {   /*  <form role="search" method="get" className="woocommerce-product-search" action="#">
                     <label className="screen-reader-text" for="woocommerce-product-search-field-0">Search for:</label>
                     <input type="search" id="woocommerce-product-search-field-0" className="search-field" placeholder="Search products…" value="" name="s" />
                     <button type="submit" value="Search">Search</button>
                     <input type="hidden" name="post_type" value="product" />
                   </form> */ }

                    
	{/* <input type="search" id="" class="search-field" placeholder="Search products…" value="" name="s" />
             */}                       
                  </div>
                  <div className="menu-right pull-right">
                    {/*Top Navigation Bar Component*/}


                    <div className="top-header">
                      {cp.includes('ack') === false || window.innerWidth > 576 ? 
                      <React.Fragment>
                      <div className="icon-nav">
                        <ul className="header-ul header-dropdown">

                        <React.Fragment>
                          {/* <li className='onhover-dropdown mobile-home mobile-icon1' onClick={() => this.onSetSidebarOpen(true)}>
                            <a>
                              <i className="fa fa-home" aria-hidden="true"></i>
                              <img src={searchDefault} style={{ width: 30, height:35}}/>
                              <div>Search</div>
                            </a>
                          </li> */}
                          <li className="onhover-dropdown mobile-wishlist mobile-icon5">
                          <Link to={'/csa-home'} style={{ textAlign: "center" ,paddingRight:10 }}>
                            <img src={homeDefault} style={{ width: 25, height:35}} />
                            <div>Home</div>
                          </Link>
                          </li>
                          {!consumer_mobile_no && 
                          <li className="onhover-dropdown mobile-account mobile_account mobile-logout"  >
                            <Link to={`/logout`} data-lng="en">
                              {/* <i className="fa fa-home" aria-hidden="true"></i> */}
                              <img src={signOutDefault} style={{ width: 27, height:35}} />
                              <div>Logout</div>
                            </Link>
                          </li>
                          }
                          {
                          consumer_mobile_no && 
                          <li className="onhover-dropdown mobile-account mobile-icon2">
                              {/* <i className="fa fa-user-o" aria-hidden="true"></i> {translate('my_account')} */}
                              <img src={signInDefault} style={{ width: 30, height:35}}/><span>My Account</span>
                              {isAuth ?
                                <ul className="onhover-show-div my-account-list">
                                  <li>
                                    <Link to={`/profile`} data-lng="en">My Profile</Link>
                                  </li>
                                  <li>
                                    <Link to={`/profile/my-orders`} data-lng="en">My Orders</Link>
                                  </li>
                               {/*    <li>
                                    <Link to={`/profile/return-orders`} data-lng="en">Return Order</Link>
                                  </li>
                                  <li>
                                    <Link to={`/profile/cancel-order`} data-lng="en">Cancel Order</Link>
                                  </li>*/}
                                  <li onClick={()=>this.handleCustomerLogout()}>
                                    <Link to=''>
                                    Logout
                                    </Link>
                                  </li> 
                                </ul>
                                :
                                <ul className="onhover-show-div">
                                  <li style={{ width: 200, display: "flex", justifyContent: "center" }}>
                                    <Link to={`/login`} data-lng="en" className="btn btn-solid" style={{ width: "100%", padding: 10, fontWeight: 600 }}>
                                      Sign In
                                     </Link>
                                  </li>
                                  <li style={{ width: 200, display: "flex", justifyContent: "center", fontSize: 11, paddingTop: 5 }}>
                                    <Link to={`/login`}><u>Don't have an account?  Register</u></Link>
                                  </li>
                                </ul>
                              }
                            </li>
                          }
                          <li className={consumer_mobile_no ? 'onhover-dropdown mobile-wishlist mobile-icon4' : 'onhover-dropdown mobile-wishlist mobile-icon4 mobile-icon-middle'}>
                            {/* <Link to={`/wishlist`}> */}
                            {/* <Link to={`/register`}> */}
                            <Link to={'/update'} style={{ textAlign: "center" }}>
                              <img src={switchAccount} style={{ width: 25, height:35}}/>
                              <div>Consumer</div>  
                            </Link>
                            {/* </Link> */}
                            {/* </Link> */}
                          </li>
                          {
                            consumer_mobile_no && 
                            <CartContainer clsName="mobile-icon3" /> 
                          }
                        </React.Fragment>
                       




                          
                          {/* <li className="mobile-home">
                            <div onClick={() => this.onSetSidebarOpen(true)}><i className="fa fa-home" aria-hidden="true">
                            </i>{translate('home')}
                            </div>
                          </li>
                    */}
                      
                    
                    
                          
                        </ul>
                      </div>
                      </React.Fragment> : '' }
                    </div>
                   {/*  <div className="before-1199"><NavBar /></div> */}
                  </div>
                </div>
              </div>
            </div>
         
        
          </div>
        </header>

        <div>
          <Sidebar
            sidebar={<Filter
              // handleApplyFilters={this.applyFilter}
              // categoryId={this.props.categoryId}
              openState={this.state.sidebarOpen}
              onSetSidebarOpen={this.onSetSidebarOpen}
            />}
            open={this.state.sidebarOpen}
            touch={false}
            pullRight
            rootClassName={"filter-panel-left"}
            sidebarClassName={"filter-side-bar"}
            overlayClassName={'filter-overlay'}
            onSetOpen={this.onSetSidebarOpen}
            styles={{ sidebar: { background: "white" } }}
          ><div/></Sidebar>
        </div>

        <div id="search-overlay" className="search-overlay">
          <div>
            <span className="closebtn" onClick={this.closeSearch} title="Close Overlay">×</span>
            <div className="overlay-content">
              <div className="container">
                <div className="row">
                  <div className="col-xl-12">
                    <form>
                      <div className="form-group">
                        <input type="text" className="form-control" id="exampleInputPassword1" placeholder="Search a Product" />
                      </div>
                      <button type="submit" className="btn btn-primary"><i className="fa fa-search"></i></button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    )
  }
}

function mapStateToProps(state) {
  return {getAllSearchResults,
    isAuth: state.user.isAuth,
    logo: state.tenant.tenantLogoURL,
    pshop_product_search : state.tenant.pshop_product_search,
    pshop_keyword_search : state.tenant.pshop_keyword_search,
    bannerText:
    state.tenant && state.tenant.header_and_store_content && state.tenant.header_and_store_content.filter(
        (item) => item.APC_ELEMENT_ID === "Banner Description"
      ) || null,
    store_id: state.store.selectedStore && state.store.selectedStore.ASM_ASSOC_CD,
    connection_id: state.tenant.connection_id,
    presentURL: state.tenant.presentURL,
    store_details: state.tenant.store_details,

    consumer_mobile_no: state.user.user_details && state.user.user_details.COM_CONSUMER_MOBILE_NO,
  }
}

export default withTranslate(connect(mapStateToProps,
  { changeCurrency ,getAllSearchResults,clearUserDetails,clearCapillaryDetails}
)(withRouter(HeaderOne)));